/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
    console.log(response)

    const offcanvasCart = document.querySelector('#offcanvas-cart')
    const cartPage = document.querySelector('#cart')

    offcanvasCart?.classList.add('loading')
    cartPage?.classList.add('loading')

    const newResponse = await fetch(window.location.href)
    const text = await newResponse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    offcanvasCart?.querySelector('.offcanvas-body')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
    offcanvasCart?.querySelector('.offcanvas-footer')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))
    cartPage?.replaceWith(newDocument.querySelector('#cart'))

    document.querySelectorAll('.cart-count-badge').forEach((badge) => {
        badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
        badge.removeAttribute('hidden')
    })

    offcanvasCart?.classList.remove('loading')
    cartPage?.classList.remove('loading')

    window.dispatchEvent(new Event('updated.ecomify.cart'))

    if (response.ok) {
        if (response.url.includes('add.js')) {
            offcanvasCart?.querySelector('#offcanvas-cart-alert-add').removeAttribute('hidden')

            const data = await response.json()

            if (data.items?.length > 1) {
                const elemAlertItemsAdded = offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-items-added]')

                elemAlertItemsAdded.textContent = elemAlertItemsAdded.textContent.replace('[count]', data.items.length)
                elemAlertItemsAdded.removeAttribute('hidden')
            } else {
                offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-item-added]')
                    .removeAttribute('hidden')
            }
        } else {
            offcanvasCart?.querySelector('#offcanvas-cart-alert-updated').removeAttribute('hidden')
        }
    } else {
        const data = await response.json()
        const alert = document.querySelector('#offcanvas-cart-alert-error')
        alert.querySelector('span').textContent = `${data.message} - ${data.description}`
        alert.removeAttribute('hidden')
    }

    if (offcanvasCart?.querySelector('#offcanvas-cart-empty')) {
        setTimeout(() => {
            bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).hide()
        }, 1000)
    }

    if (offcanvasCart?.querySelector('#cart-shipping-rates')) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector('shipping-rates-modal-country', 'shipping-rates-modal-province', {
            hideElement: 'shipping-rates-modal-province-wrapper'
        })
    }
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: input.dataset.lineItemKey,
            quantity: input.value
        })
    })
    window.refreshCartContents(response)
}

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: btn.dataset.lineItemKey,
            quantity: 0
        })
    })
    window.refreshCartContents(response)
}

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const note = btn.closest('#cart-note').querySelector('[name="note"]').value

    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
    })

    btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textBtnSave
    }, 4000)
}

// Checkout button - indicate loading on click
window.onClickCheckoutBtn = (btn) => {
    if (!window.__allowDirectCheckoutSpinner) return

    btn.style.height = btn.clientHeight + 'px'
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
}

const ARTWORK_VECTOR_PRODUCT_HANDLE = 'professional-vector-design-services'
const ARTWORK_ATTR_KEY = 'Artwork'
const ARTWORK_OPTION_PRINT_AS_IS = 'Print As Is – The file will be printed exactly as uploaded.'
const ARTWORK_OPTION_QUALITY_CHECK = 'Contact Me – If we detect issues such as pixelation, blurriness, white backgrounds, low resolution, or other problems that could affect the final print quality.'
const ENABLE_ARTWORK_CONFIRMATION_POPUP = false
let artworkCheckoutFlowRunning = false

const fetchCartJson = async () => {
    const response = await fetch('/cart.js', { cache: 'no-store' })
    return response.json()
}

const shouldSkipArtworkConfirmation = (cart) => {
    if (!cart?.items?.length) return false
    return cart.items.every((item) => item.handle === ARTWORK_VECTOR_PRODUCT_HANDLE)
}

const getCheckoutHrefIfAny = (elem) => {
    if (!elem) return null

    const anchor = elem.closest?.('a[href]')
    if (!anchor) return null

    let url
    try {
        url = new URL(anchor.href, window.location.origin)
    } catch {
        return null
    }

    if (url.origin !== window.location.origin) return null
    if (!['/checkout', '/cart/checkout'].includes(url.pathname)) return null

    return anchor.href
}

const ensureArtworkConfirmationStyles = () => {
    if (document.querySelector('#artwork-confirmation-style')) return

    document.head.insertAdjacentHTML('beforeend', `
        <style id="artwork-confirmation-style">
            #artwork-confirmation-modal .modal-dialog {
                max-width: 560px;
                margin: 1.75rem auto;
            }
            #artwork-confirmation-modal .modal-content {
                border: 0;
                border-radius: 18px;
                background: #f3f3f4;
                padding: 14px 20px 20px;
                box-shadow: 0 8px 28px rgba(0, 0, 0, .12);
            }
            #artwork-confirmation-modal .modal-header {
                border: 0;
                padding: 0;
                justify-content: flex-end;
            }
            #artwork-confirmation-modal .btn-close {
                box-shadow: none;
                opacity: .35;
                transform: scale(1.08);
            }
            #artwork-confirmation-modal .modal-body {
                padding: 0 4px 0;
            }
            #artwork-confirmation-modal .artwork-confirmation-icon {
                width: 94px;
                height: 94px;
                border-radius: 999px;
                margin: 0 auto 16px;
                background: #e5e7ea;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            #artwork-confirmation-modal .artwork-confirmation-title {
                text-align: center;
                font-size: clamp(1.9rem, 1.3rem + 1vw, 2.4rem);
                font-weight: 600;
                color: #2f3135;
                line-height: 1.15;
                margin: 0 0 8px;
            }
            #artwork-confirmation-modal .artwork-confirmation-subtitle {
                text-align: center;
                color: #3f4248;
                font-size: 1.35rem;
                margin: 0 0 16px;
            }
            #artwork-confirmation-modal .form-check {
                margin-bottom: 12px;
                background: #fff;
                border: 1px solid #d6d9df;
                border-radius: 12px;
                padding: 12px 12px 12px 44px;
            }
            #artwork-confirmation-modal .form-check-label {
                color: #2f3135;
                font-size: 1.35rem;
                line-height: 1.4;
                font-weight: 500;
            }
            #artwork-confirmation-modal .form-check-input {
                width: 1.25rem;
                height: 1.25rem;
                margin-top: .2rem;
                margin-left: -1.85rem;
                border: 2px solid #9ca3af;
            }
            #artwork-confirmation-modal .form-check-input:checked {
                background-color: #9f1525;
                border-color: #9f1525;
            }
            #artwork-confirmation-modal #artwork-confirmation-options {
                background: #fff;
                border-radius: 14px;
                padding: 10px;
                border: 1px solid #d6d9df;
            }
            #artwork-confirmation-modal .modal-footer {
                border: 0;
                padding: 12px 0 0;
                justify-content: center;
            }
            #artwork-confirmation-modal #artwork-confirmation-continue {
                border: 0;
                border-radius: 20px;
                background: #9f1525;
                color: #fff;
                padding: 12px 26px;
                font-size: 1.65rem;
                font-weight: 600;
                line-height: 1.1;
                min-width: 240px;
            }
            #artwork-confirmation-modal #artwork-confirmation-continue:disabled {
                opacity: .55;
            }
            @media (max-width: 767px) {
                #artwork-confirmation-modal .modal-dialog {
                    max-width: calc(100% - 1rem);
                    margin: .5rem auto;
                }
                #artwork-confirmation-modal .modal-content {
                    padding: 12px 14px 18px;
                    border-radius: 18px;
                }
                #artwork-confirmation-modal .artwork-confirmation-icon {
                    width: 78px;
                    height: 78px;
                    margin-bottom: 12px;
                }
                #artwork-confirmation-modal .artwork-confirmation-subtitle {
                    font-size: 1.2rem;
                    margin-bottom: 12px;
                }
                #artwork-confirmation-modal .form-check-label {
                    font-size: 1.1rem;
                }
                #artwork-confirmation-modal #artwork-confirmation-continue {
                    width: 100%;
                    min-width: 0;
                    font-size: 1.25rem;
                    border-radius: 16px;
                    padding: 13px 16px;
                }
            }
        </style>
    `)
}

const ensureArtworkConfirmationModal = () => {
    if (document.querySelector('#artwork-confirmation-modal')) return

    ensureArtworkConfirmationStyles()

    document.body.insertAdjacentHTML('beforeend', `
        <div class="modal fade" id="artwork-confirmation-modal" tabindex="-1" aria-labelledby="artwork-confirmation-modal-title" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="artwork-confirmation-icon" aria-hidden="true">
                            <img
                                src="https://dtfvirginia.com/cdn/shop/files/Cardinal_Laptop_e432c837-cba1-461b-ad32-4be84cb903ab.svg?v=1758100461"
                                alt=""
                                width="54"
                                height="54"
                                loading="lazy">
                        </div>
                        <h5 class="artwork-confirmation-title" id="artwork-confirmation-modal-title">Artwork Confirmation</h5>
                        <p class="artwork-confirmation-subtitle">Please confirm before continuing to checkout.</p>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="1" id="artwork-confirmation-checkbox">
                            <label class="form-check-label" for="artwork-confirmation-checkbox">
                                I have double checked my artwork to ensure it meets the guidelines!
                            </label>
                        </div>

                        <div id="artwork-confirmation-options" class="mt-4" hidden>
                            <div class="form-check mb-2">
                                <input class="form-check-input" type="radio" name="artwork_confirmation_option" id="artwork-option-print-as-is" value="${ARTWORK_OPTION_PRINT_AS_IS}">
                                <label class="form-check-label" for="artwork-option-print-as-is">
                                    ${ARTWORK_OPTION_PRINT_AS_IS}
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="artwork_confirmation_option" id="artwork-option-quality-check" value="${ARTWORK_OPTION_QUALITY_CHECK}">
                                <label class="form-check-label" for="artwork-option-quality-check">
                                    ${ARTWORK_OPTION_QUALITY_CHECK}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" id="artwork-confirmation-continue" disabled>Continue to Checkout</button>
                    </div>
                </div>
            </div>
        </div>
    `)
}

const askArtworkConfirmation = async () => {
    ensureArtworkConfirmationModal()

    const modalElem = document.querySelector('#artwork-confirmation-modal')
    const checkbox = modalElem.querySelector('#artwork-confirmation-checkbox')
    const optionsWrapper = modalElem.querySelector('#artwork-confirmation-options')
    const radios = modalElem.querySelectorAll('[name="artwork_confirmation_option"]')
    const continueBtn = modalElem.querySelector('#artwork-confirmation-continue')
    const modal = bootstrap.Modal.getOrCreateInstance(modalElem, {
        backdrop: 'static',
        keyboard: false
    })

    checkbox.checked = false
    optionsWrapper.setAttribute('hidden', 'hidden')
    continueBtn.disabled = true
    radios.forEach((radio) => {
        radio.checked = false
    })

    const updateContinueState = () => {
        const selectedOption = modalElem.querySelector('[name="artwork_confirmation_option"]:checked')
        continueBtn.disabled = !checkbox.checked || !selectedOption
    }

    return new Promise((resolve) => {
        let resolved = false

        const handleCheckboxChange = () => {
            if (checkbox.checked) {
                optionsWrapper.removeAttribute('hidden')
            } else {
                optionsWrapper.setAttribute('hidden', 'hidden')
                radios.forEach((radio) => {
                    radio.checked = false
                })
            }
            updateContinueState()
        }

        const handleRadioChange = () => {
            updateContinueState()
        }

        const handleHidden = () => {
            checkbox.removeEventListener('change', handleCheckboxChange)
            radios.forEach((radio) => {
                radio.removeEventListener('change', handleRadioChange)
            })
            continueBtn.removeEventListener('click', handleContinue)
            modalElem.removeEventListener('hidden.bs.modal', handleHidden)

            if (!resolved) {
                resolve(null)
            }
        }

        const handleContinue = () => {
            const selectedOption = modalElem.querySelector('[name="artwork_confirmation_option"]:checked')
            if (!checkbox.checked || !selectedOption) return

            resolved = true
            resolve(selectedOption.value)
            modal.hide()
        }

        checkbox.addEventListener('change', handleCheckboxChange)
        radios.forEach((radio) => {
            radio.addEventListener('change', handleRadioChange)
        })
        continueBtn.addEventListener('click', handleContinue)
        modalElem.addEventListener('hidden.bs.modal', handleHidden)

        modal.show()
    })
}

const applyArtworkOptionToCart = async (cart, artworkOption) => {
    const itemsToUpdate = cart.items.filter((item) => item.handle !== ARTWORK_VECTOR_PRODUCT_HANDLE)

    for (const item of itemsToUpdate) {
        const properties = { ...(item.properties || {}) }
        properties[ARTWORK_ATTR_KEY] = artworkOption

        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: item.key,
                quantity: item.quantity,
                properties
            })
        })
    }
}

window.startArtworkConfirmationCheckout = async () => {
    if (!ENABLE_ARTWORK_CONFIRMATION_POPUP) {
        window.location.href = '/checkout'
        return true
    }

    if (artworkCheckoutFlowRunning) return false

    artworkCheckoutFlowRunning = true

    try {
        const cart = await fetchCartJson()

        if (shouldSkipArtworkConfirmation(cart)) {
            window.location.href = '/checkout'
            return true
        }

        const selectedArtworkOption = await askArtworkConfirmation()
        if (!selectedArtworkOption) return false

        await applyArtworkOptionToCart(cart, selectedArtworkOption)
        window.location.href = '/checkout'
        return true
    } catch (error) {
        console.error('Artwork confirmation flow failed:', error)
        window.location.href = '/checkout'
        return true
    } finally {
        artworkCheckoutFlowRunning = false
    }
}

const initArtworkCheckoutInterception = () => {
    if (!ENABLE_ARTWORK_CONFIRMATION_POPUP) return

    document.addEventListener('submit', async (event) => {
        const form = event.target
        if (!(form instanceof HTMLFormElement)) return

        const submitter = event.submitter

        const isCheckoutSubmit = Boolean(
            submitter?.name === 'checkout'
            || submitter?.classList?.contains('btn-checkout')
            || form.querySelector('[name="checkout"]')
        )

        if (!isCheckoutSubmit) return
        if (event.defaultPrevented) return

        event.preventDefault()
        event.stopImmediatePropagation()

        window.__artworkConfirmationHandledCheckoutClick = true
        await window.startArtworkConfirmationCheckout()
        window.__artworkConfirmationHandledCheckoutClick = false
    }, true)

    document.addEventListener('click', async (event) => {
        const checkoutHref = getCheckoutHrefIfAny(event.target)
        if (!checkoutHref) return
        if (event.defaultPrevented) return

        event.preventDefault()
        event.stopImmediatePropagation()

        window.__artworkConfirmationHandledCheckoutClick = true
        await window.startArtworkConfirmationCheckout()
        window.__artworkConfirmationHandledCheckoutClick = false
    }, true)
}
initArtworkCheckoutInterception()

// Cart Goal - Animate width
const initCartGoal = () => {
    const progressBar = document.querySelector('#cart-goal .progress-bar')
    if (progressBar) {
        setTimeout(() => {
            progressBar.style.width = progressBar.dataset.width
        }, 250)
    }
}
initCartGoal()

window.addEventListener('updated.ecomify.cart', () => {
    initCartGoal()
})

// Cart Goal - Free product
const initCartGoalFreeProduct = async () => {
    const cartGoal = document.querySelector('#cart-goal')
    if (!cartGoal) return

    const freeProductHandle = cartGoal.dataset.freeProductHandle
    if (!freeProductHandle.length) return

    const goalCompleted = cartGoal.dataset.goalCompleted === '2'
    let isFreeProductInCart = false

    document.querySelectorAll('[data-cart-line-item]').forEach(elem => {
        if (elem.dataset.productHandle === freeProductHandle) {
            isFreeProductInCart = true
        }
    })

    const freeProductVariantId = Number(cartGoal.dataset.freeProductVariantId)

    if (goalCompleted) {
        if (!isFreeProductInCart) {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: freeProductVariantId,
                        quantity: 1
                    }]
                })
            })
            window.refreshCartContents(response)
        }
    }

    console.log(freeProductHandle)
}
initCartGoal()

window.addEventListener('updated.ecomify.cart', () => {
    initCartGoalFreeProduct()
})

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
    const card = document.querySelector('#cart-summary')

    if (!card) return

    if (window.matchMedia('max-width: 991px').matches) return

    const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
    const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

    card.style.position = 'sticky'
    card.style.top = `${navbarHeight + announcementBarHeight + 20}px`
}
initStickySummaryCard()

window.addEventListener('updated.ecomify.cart', () => {
    initStickySummaryCard()
})

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const wrapper = document.querySelector('#cart-shipping-rates-collapse')

    wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-danger').setAttribute('hidden', 'hidden')
    wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-warning').setAttribute('hidden', 'hidden')
    wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-success').setAttribute('hidden', 'hidden')

    const country = wrapper.querySelector('#shipping-rates-modal-country').value
    const province = wrapper.querySelector('#shipping-rates-modal-province').value
    const zip = wrapper.querySelector('#shipping-rates-modal-zip').value

    const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
        method: 'POST'
    })
    console.log(prepareResponse)

    if (prepareResponse.ok) {
        const asyncRespose = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`)
        console.log(asyncRespose)

        const data = await asyncRespose.json()
        console.log(data)

        let html = ''

        if (data.shipping_rates.length) {
            data.shipping_rates.forEach(elem => {
                html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `
            })

            wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = `
                <ul class="ps-5 mb-0">
                    ${html}
                </ul>
            `
            wrapper.querySelector('#shipping-rates-modal-alert-success').removeAttribute('hidden')
        } else {
            wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = `
                <p class="mb-0">
                    ${wrapper.dataset.textNoResults}
                </p>
            `
            wrapper.querySelector('#shipping-rates-modal-alert-warning').removeAttribute('hidden')
        }
    } else {
        const data = await prepareResponse.json()
        console.log(data)

        let html = ''

        for (const [key, value] of Object.entries(data)) {
            html += `
                <li>
                    <strong>${key}</strong>: ${value.toString()}
                </li>
            `
        }

        wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = `
            <ul class="ps-5 mb-0">
                ${html}
            </ul>
        `
        wrapper.querySelector('#shipping-rates-modal-alert-danger').removeAttribute('hidden')
    }

    btn.innerHTML = btn.dataset.text
}

// Offcanvas cart - fix scrolling for callapses
const fixScrollingOffcanvasCollapses = () => {
    document.querySelectorAll('#offcanvas-cart [data-bs-toggle="collapse"]').forEach(elem => {
        elem.addEventListener('click', () => {
            setTimeout(() => {
                const offcanvasBody = document.querySelector('#offcanvas-cart .offcanvas-body')
                offcanvasBody.scroll({ top: offcanvasBody.scrollHeight, behavior: 'smooth' })
            }, 250)
        })
    })
}
fixScrollingOffcanvasCollapses()

window.addEventListener('updated.ecomify.cart', () => {
    fixScrollingOffcanvasCollapses()
})

// Upgrade to subscription
window.onChangeCartUpgradeToSub = async (select) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: select.dataset.lineItemKey,
            quantity: 0
        })
    })

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                quantity: Number(select.dataset.quantity),
                id: Number(select.dataset.variantId),
                selling_plan: Number(select.value)
            }]
        })
    })

    window.refreshCartContents(response)
}

// Gift Wrap
window.onChangeCartGiftWrap = async (input) => {
    let response

    if (input.checked) {
        response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: Number(input.value)
                }]
            })
        })
    } else {
        response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: input.dataset.lineItemKey,
                quantity: 0
            })
        })
    }
    window.refreshCartContents(response)
}

// Cart Min Order
const initCartMinOrder = () => {
    const wrapper = document.querySelector('#cart-min-order')
    if (!wrapper) return

    if (wrapper.dataset.goalReached === 'false') {
        wrapper.closest('form').querySelector('.btn-checkout').disabled = true
    }
}
initCartMinOrder()
window.addEventListener('updated.ecomify.cart', () => {
    initCartMinOrder()
})

// Shipping protection
const initCartShippingProtection = async () => {
    if (!document.querySelector('[data-shipping-protection-enabled="true"]')) return
    if (!document.querySelector('[data-shipping-protection-auto-init="true"]')) return

    if (!window.localStorage.getItem('ecomify-shipping-protection-init')) {
        const variantId = Number(document.querySelector('[data-shipping-protection-variant-id]').dataset.shippingProtectionVariantId)

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: variantId
                }]
            })
        })

        window.refreshCartContents(response)
        window.localStorage.setItem('ecomify-shipping-protection-init', true)
    }
}
window.addEventListener('updated.ecomify.cart', () => {
    initCartShippingProtection()
})

window.onChangeCartShippingProtection = async (input) => {
    let response

    if (input.checked) {
        response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: Number(input.value)
                }]
            })
        })
    } else {
        response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: input.dataset.lineItemKey,
                quantity: 0
            })
        })
    }
    window.refreshCartContents(response)
}

// Variant switcher
window.onChangeCartLineItemVariant = async (select) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: select.dataset.lineItemKey,
            quantity: 0
        })
    })

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                quantity: Number(select.dataset.quantity),
                id: Number(select.value),
                selling_plan: select.dataset.sellingPlanId.length
                    ? Number(select.dataset.sellingPlanId)
                    : null
            }]
        })
    })

    window.refreshCartContents(response)
}

// Terms checkbox
const initTermsCheckbox = () => {
    const checkbox = document.querySelector('#cart-terms-checkbox')

    if (!checkbox) return

    const checkoutBtn = checkbox.closest('form').querySelector('.btn-checkout')
    checkoutBtn.disabled = true

    checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
            checkoutBtn.disabled = false
        } else {
            checkoutBtn.disabled = true
        }
    })
}
initTermsCheckbox()

window.addEventListener('updated.ecomify.cart', () => {
    initTermsCheckbox()
})

// Cart Discount
window.onCartDiscountClick = async (btn) => {
    const wrapper = document.querySelector('#cart-discount')

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    await fetch(`/discount/${wrapper.querySelector('.form-control').value}`)
    await window.startArtworkConfirmationCheckout()
}
